

export default function Header({text}) {
  return (
    <h2 className="header" >{text}</h2>
  );
}